
import mapboxgl from 'mapbox-gl'
import PopupContent from '../../components/PopupContent';
import * as moment from "moment";

const VALUECOLORCODES = {
  PM10Colors: [[-9999, '#5f5f5f'], [0, '#5E4FA2'], [25, '#3288BD'], [50, '#66C2A5'], [75, '#ABDDA4'], [100, '#E6F598'], [125, '#FFFFBF'], [150, '#FEE08B'], [175, '#FDAE61'], [200, '#F46D43'], [225, '#D53E4F'], [250, '#9E0142']],
  PM25Colors: [[-9999, '#5f5f5f'], [0, '#5E4FA2'], [5, '#3288BD'], [10, '#66C2A5'], [15, '#ABDDA4'], [20, '#E6F598'], [25, '#FFFFBF'], [30, '#FEE08B'], [35, '#FDAE61'], [40, '#F46D43'], [50, '#D53E4F'], [60, '#9E0142']],
  NO2Colors: [[-9999, '#5f5f5f'], [0, '#66C2A5'], [10, '#ABDDA4'], [20, '#E6F598'], [40, '#FFFFBF'], [60, '#FEE08B'], [80, '#FDAE61'], [100, '#F46D43'], [120, '#D53E4F'], [140, '#9E0142']]
}


var infopopup = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false
});
var infopopupobs = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false
});
var clusterLeaves = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false
}).setMaxWidth("300px");

var infotextpopup = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false
});

const Mapboxgl = {
  map: {
    container: 'map',
    style: 'mapbox://styles/mapbox/light-v9',
    center: [10.307778, 60.990556],
    zoom: 5.5,
    attributionControl: false
  },

  accessToken:{
    key: 'pk.eyJ1IjoiZnJlbWlyIiwiYSI6ImNrN2V0c3l6czB1M3EzZnBxd2swZDUxeXUifQ.x4xWzhm3Na1MjMuxBevc8Q'
  },

  sensorstatus:{
    colorcodes:   [[0, '#0ab45a'], [1, '#f9d53d'], [2, '#aa0a3c'], [3, '#606060']],
    colorcodesparam: VALUECOLORCODES
  },

  //Convert hex color to rgb and set the opacity
  hexToRgb(h, opacity){

    let r = 0, g = 0, b = 0;
  
    // 3 digits
    if (h.length == 4) {
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];
  
    // 6 digits
    } else if (h.length == 7) {
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }
    
    return "rgb("+ +r + "," + +g + "," + +b + "," + opacity +  ")";
    
  },

  symbollayercolor(name, sourcename, sensorstatus, iconid) {
    return {
        id: `${name}_layer`,
        source: sourcename,
        type: 'symbol',
        layout: {
          'icon-image': iconid, // reference the image
          'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.3, 15, 0.7],
          'icon-allow-overlap': true
        },
          paint: {
            'icon-color': 
            {property: 'statuscolor', stops: sensorstatus.colorcodes}, 
          
          }
    };
  },
  circlelayercolor(name, sourcename, sensorstatus) {
    return {
        id: `${name}_layer`,
        source: sourcename,
        type: 'circle',
        paint: {
          'circle-radius': 7,
          'circle-color': {
            property: 'statuscolor', 
            stops: sensorstatus.colorcodes}, 
        }
    };
  },
  symbollayer(name, sourcename) {
    return {
        id: `${name}_layer`,
        source: sourcename,
        type: 'circle',

        paint: {
          'circle-radius': 7,
          'circle-color': "#696969"
        }
    };
  },

  simplecirclelayer(name, sourcename, colorcodes){
    return {
         id: `${name}_layer`,
         type: 'circle', 
         source: sourcename,
         paint: {
            'circle-radius': 15,
            'circle-color': {
              property: 'value',
               stops: VALUECOLORCODES[colorcodes] 
          },
        } 
    }
  },

  simplecirclelayerNew(name, sourcename, colorcodes){
    return {
         id: `${name}_layer`,
         type: 'circle', 
         source: sourcename,
         paint: {
            'circle-radius': 15,
            'circle-color': {
              property: 'value',
              stops: VALUECOLORCODES[colorcodes] 
          }
        } 
    }
  },

  simplecirclevaluelayer(name, sourcename, colorcodes){
    return {
         id: `${name}_valuelayer`,
         type: 'symbol', 
         source: sourcename,
         filter: ['!=', 'cluster', true],
          'layout': {
              'text-field': [
                  'number-format',
                  ['get', 'value'],
                  { 'min-fraction-digits': 0, 'max-fraction-digits': 0.1 }
              ],
              'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
              'text-size': 11
          },
          paint: {
              'text-color': 'black'
          } 
    }
  },

  simplecirclelayeClusterCount(name, sourcename){
    return {
         id: `${name}_clustercountlayer`,
         type: 'symbol', 
         source: sourcename,
         layout: {
          "text-field": "{point_count_abbreviated}",
          "text-size": 14,
          'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold']
        },
        paint: {
            "text-color": "white",
        }
    }
  },

  simplecirclepointLayer(name, sourcename, colorcodes){
    return {
         id: `${name}_pointLayer`,
         type: 'circle', 
         source: sourcename,
         paint: {
            'circle-radius': 10,
            'circle-color': {
              property: 'value',
              stops: VALUECOLORCODES[colorcodes] 
          },
        
        } 
    }
  },

  simplecirclepointLayerNew(name, sourcename, colorcodes){
    return {
         id: `${name}_pointLayer`,
         type: 'circle', 
         source: sourcename,
         paint: {
            'circle-radius': 10,
            'circle-color': {
              property: 'value',
              stops: VALUECOLORCODES[colorcodes] 
          },
        
        } 
    }
  },

  rasterlayer(id, source) {
    return {
        id: id,
        type: 'raster',
        source: source,
        paint: {
            'raster-fade-duration': 0,
            'raster-opacity': 0.5 
        }
    };
  },

  geojsonsource(data) {
    return {
        type: 'geojson',
        data: data,
      };
  },

  geojsonsourcecluster(data) {
    return {
        type: 'geojson',
        data: data,
        cluster: true
      }
  },

  rastersource(tiles){
    return {
        type: 'raster',
        tiles: tiles,
        'tileSize': 256
    }
  },

  imagesource(url, coordinates){
    return {
        type: 'image',
        url: url,
        coordinates:[
            [coordinates.latlonboundingbox.minx, coordinates.latlonboundingbox.maxy], 
            [coordinates.latlonboundingbox.maxx, coordinates.latlonboundingbox.maxy],
            [coordinates.latlonboundingbox.maxx, coordinates.latlonboundingbox.miny],
            [coordinates.latlonboundingbox.minx, coordinates.latlonboundingbox.miny]
        ]
    }
  },

  popup: function(e, sensors, map){
    if (e.features) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        
        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        new mapboxgl.Popup({ className: 'mappopups' })
          .setLngLat(coordinates)
          .setHTML('<div class="mappopups" id="vue-popup-content"></div>')
          .setMaxWidth("1200px")
          .addTo(map);

        new PopupContent({
            propsData: { 
              feature: e.features[0],
              sensor: sensors.find(s => {
                return s.id === e.features[0].properties.id
              })
            },
        }).$mount('#vue-popup-content');
    }
  },

  clusterExpansionZoom:  function(e, map,layers,cluster){
    const features = map.queryRenderedFeatures(e.point, {
      layers: [layers]
    });
    const clusterId = features[0].properties.cluster_id;
    map.getSource(cluster).getClusterExpansionZoom(
    clusterId,
    (err, zoom) => {
    if (err) return;
    let point_count = features[0].properties.point_count;
    let numbers = parseInt(point_count) ? parseInt(point_count) : 0;
    if(numbers > 0 ){
      map.easeTo({
        center: features[0].geometry.coordinates,
        zoom: zoom
        });
    }
    
    }
    );
  },

  clusterLeaves:  function(e, map,layers,cluster){
    map.getCanvas().style.cursor = 'pointer';
    var features = map.queryRenderedFeatures(e.point, { layers: [layers] });
    var coordinates = e.features[0].geometry.coordinates.slice();
    var clusterId = features[0].properties.cluster_id,
    point_count = features[0].properties.point_count,
    clusterSource = map.getSource(cluster);
    // Get all points under a cluster
    let arr = [];
    let numbers = parseInt(point_count) ? parseInt(point_count) : 0;
    if(numbers > 0 ){
      clusterSource.getClusterLeaves(clusterId, point_count, 0, function(err, aFeatures){
      aFeatures.forEach(sensorLeave => {
          arr.push([" "+"Id:" + sensorLeave.properties.id+",Name:" +sensorLeave.properties.name]);
      });
      clusterLeaves.setLngLat(coordinates).setHTML( `${arr}`).addTo(map);
    })
    }
  },

  clusterLeavesclose:  function(map){
    map.getCanvas().style.cursor = '';
    clusterLeaves.remove();
  },

  infopopup:  function(e, map){
    map.getCanvas().style.cursor = 'pointer';
    var coordinates = e.features[0].geometry.coordinates.slice();
    var name = e.features[0].properties.name;
  
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }
     
    infopopup.setLngLat(coordinates).setHTML(name).addTo(map);
  },

  infopopupclose:  function(map){
    map.getCanvas().style.cursor = '';
    infopopup.remove();
  },

  infotextpopup:  function(e, map){
    map.getCanvas().style.cursor = 'pointer';
    var coordinates = e.features[0].geometry.coordinates.slice();
    var name = e.features[0].properties.name;
    var statustext = e.features[0].properties.statustext;
  
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }
     
    infotextpopup.setLngLat(coordinates).setHTML(`<b>${name}</b><br/>(${statustext})`).addTo(map);
  },

  infotextpopupclose:  function(map){
    map.getCanvas().style.cursor = '';
    infotextpopup.remove();
  },

  infopopupobs:  function(e, map){
    map.getCanvas().style.cursor = 'pointer';
    var name = e.features[0].properties.name;
    var coordinates = e.features[0].geometry.coordinates.slice();
    var component = e.features[0].properties.component;
    var value = e.features[0].properties.value;
    var unit = e.features[0].properties.unit;
    var timeutc =  moment(e.features[0].properties.timestamp_to_epoch * 1000).utc().format('YYYY-MM-DD HH:mm')
  
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }
    if(name){
      infopopupobs.setLngLat(coordinates).setHTML( `<b>${name}</b><br/><b>${timeutc} UTC </b><br/>${value} ${unit} (${component})`).addTo(map);
    }
  },

  infopopupobsclose:  function(map){
    map.getCanvas().style.cursor = '';
    infopopupobs.remove();
  },

  onLayerSelect: function(e, map){
    if(e.checked){
      map.setLayoutProperty(`${e.name}_layer`, 'visibility', 'visible');
      if(`${e.name}_layer`.includes("Last available hour")){
        map.setLayoutProperty(`${e.name}_valuelayer`, 'visibility', 'visible');
        map.setLayoutProperty(`${e.name}_clustercountlayer`, 'visibility', 'visible');
      }
      else if(`${e.name}_layer`.includes("mobile sensors")){
        map.setLayoutProperty(`${e.name}_valuelayer`, 'visibility', 'visible');
      }
    }
    else{
      map.setLayoutProperty(`${e.name}_layer`, 'visibility', 'none');
      if(`${e.name}_layer`.includes("Last available hour")){
        map.setLayoutProperty(`${e.name}_valuelayer`, 'visibility', 'none');
        map.setLayoutProperty(`${e.name}_clustercountlayer`, 'visibility', 'none');
      }
      else if(`${e.name}_layer`.includes("mobile sensors")){
        map.setLayoutProperty(`${e.name}_valuelayer`, 'visibility', 'none');
      }
    }
  },

  onLayerRemove: function(layer, source, map)
  {
    if (map.getLayer(layer)){ 
        map.removeLayer(layer);
    }
    if (map.getSource(source)) {
        map.removeSource(source);
    }
  },

};

export default Mapboxgl;
